<div class="stat-container">
    <div class="awayStat">{{away}}</div>
    <div class="statName">{{stat}}</div>
    <div class="homeStat">{{home}}</div>
  </div>